export const CREDIT_RESET_TIME_ZONE = 'America/New_York';

const easternYear = date => date.toLocaleDateString('en-US', {
  timeZone: CREDIT_RESET_TIME_ZONE, year: 'numeric',
});

/** Match the backend's Eastern billing calendar regardless of device time zone. */
export function formatCreditResetDate(date, now = new Date()) {
  if (!date) return '';
  const parsed = date instanceof Date ? date : new Date(date);
  if (!Number.isFinite(parsed.getTime())) return '';
  const options = { timeZone: CREDIT_RESET_TIME_ZONE, month: 'short', day: 'numeric' };
  if (easternYear(parsed) !== easternYear(now)) options.year = 'numeric';
  return parsed.toLocaleDateString('en-US', options);
}

export function formatCreditResetSchedule(date, now = new Date()) {
  const label = formatCreditResetDate(date, now);
  if (!label) return '';
  const time = new Date(date).toLocaleTimeString('en-US', {
    timeZone: CREDIT_RESET_TIME_ZONE, hour: 'numeric', minute: '2-digit',
  });
  return `${label} at ${time} ET`;
}
